<template>
  <b-container fluid class="bg-light-gray h-100 pt-4">
    <b-jumbotron class="shadow p-5 bg-white rounded mx-auto my-auto w-50 text-center">
      <h3 class="my-2">Exam Complete</h3>
      <b-form>
        <b-button class="mx-auto w-100 mt-2" @click="logout" variant="secondary">Logout</b-button>
      </b-form>
    </b-jumbotron>
  </b-container>
</template>

<script>
export default {
  name: "ExamineeResult",
  methods: {
    logout() {
      const username = this.$store.getters[`user/username`];
      this.$store
        .dispatch(`user/logout`, { username })
        .then(() => {
          this.$router.push("/login");
        })
        .catch((err) => {
          this.loginError = err.message;
          this.$router.push("/login");
        });
    },
  },
};
</script>

<style lang="css" scoped>
.termsAndConditionContainer {
  overflow-y: scroll;
  height: 350px;
}
</style>